import { render, staticRenderFns } from "./select-purchase-modal.vue?vue&type=template&id=e1b995fc&scoped=true&"
import script from "./select-purchase-modal.vue?vue&type=script&lang=ts&"
export * from "./select-purchase-modal.vue?vue&type=script&lang=ts&"
import style0 from "./select-purchase-modal.vue?vue&type=style&index=0&id=e1b995fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b995fc",
  null
  
)

export default component.exports